const roundWith2Decimal = (num) => (Math.round(num * 100) / 100).toFixed(2)

export { roundWith2Decimal }
